<template>
	<div class="EOutStock">
		<div class="tit">{{Language.LG.PleaseInput[isLanguage]}}</div>
		<div class="Outform">
			<div class="item">
				<label class="label">{{Language.LG.LastFour[isLanguage]}}</label>
				<div class="itCont">
					<div class="inputSpan w280">
						<validcode ref="code" :maxlength="4" :isPwd="false" @finish="getCode" :reTime="reTime"></validcode>
					</div>
				</div>
			</div>
			<div class="item">
				<label class="label">{{Language.LG.PickPassword[isLanguage]}}</label>
				<div class="itCont">
					<div class="inputSpan w420">
						<validcode ref="code" :maxlength="6" :isPwd="false" @finish="getCode2" :reTime="reTime"></validcode>
					</div>
				</div>
			</div>
			<div class="confirmBtn" @click="openBox('2')">
				<span>{{Language.LG.Collect[isLanguage]}}</span>
				<span class="time" v-if="isCount">{{CountTime}}s</span>
			</div>
		</div>
		
		<div class="outCont" :class="{'isEnglish':isLanguage==1}">
			<div class="item">{{Language.LG.OutStockTips[isLanguage]}}</div>
			<div class="item" v-html="Language.LG.OutStockStep[isLanguage]"></div>
		</div>
		
		<!--超时组件-->
		<overTime :callBack="quit"></overTime>
		
		<!--按钮组-->
		<EConfigBtn :pushBg="'#31a3dc'" :backUp="backUp" :quit="quit"></EConfigBtn>
		
	</div>
</template>

<script>
	import overTime from '../assets/overTime.vue'
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import { EloginApi } from '../../../../static/CESite40s/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	import { websocketsend } from '../../../../static/js/utils/socket.js'
	var vm
	export default {
		data() {
			return {
				configStorage:null,
				
				isLanguage:0,
				Language:'',
				Outform:{
					LastFour:'',//手机号后4位
					PickPassword:'',//取件密码
					order_id:'',//订单号
				},
				
				//右侧取件按钮的超时
				CountTime:60,
				CountTimeStatus:'',
				isCount:true,
			};
		},
		async created(){
			vm = this

			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			
			this.$store.state.overTime = 80
			
			this.scanCode();//开始扫码
			this.CountDown(this.CountTime);//倒计时
		},
		components:{
			overTime,
			EConfigBtn
		},
		
		methods:{
			//获取ws消息
			getSkMsg(res){
				conLog('getSkMsg',res)
				let str = res.substring(34,res.length-2)
				let typeNum = res.substring(26,30)
				str = hexCharCodeToStr(str)
				conLog('快递号',str)
				//f500功能码
				if(typeNum == 'f500'){
					vm.Outform.order_id = str
					vm.openBox('1')
				}
			},
			//开始扫码
			async scanCode(){
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备ID
				}
				const res = await EloginApi.scanCode(data)
				if(res){
					if(res.meta.code==200){
						websocketsend('a5552003121118520000000001f50000010090')
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//取消扫码
			async cancelScanCode(){
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备ID
				}
				const res = await EloginApi.cancelScanCode(data)
				if(res){
					if(res.meta.code==200){

					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//取件
			async openBox(type){
				if(type == '2'){
					if(vm.Outform.LastFour==''){
						vm.$message({
							message: '请输入手机后四位',
							type: 'error',
							duration:1000
						});
						return
					}
					if(vm.Outform.PickPassword==''){
						vm.$message({
							message: '请输入开箱密码',
							type: 'error',
							duration:1000
						});
						return
					}
				}else{
					if(vm.Outform.order_id == ''){
						vm.$message({
							message: '未扫到订单号',
							type: 'error',
							duration:1000
						})
					}
				}
				const _obj = {
					'open_password': vm.Outform.PickPassword,//开箱密码
					'phone_no': vm.Outform.LastFour,//手机后四位
				}
				let data = {
					'open_type':type,//1为订单号开箱，2为密码开箱
					'cabinet_id': vm.configStorage.deviceId,//设备ID
					'open_box':'1',//是否超前支付开箱，1开，2不开
					'pay_way':'-1',//支付方式，-1不支付，1投币，2微信扫码，3支付宝扫码，5微信网页支付
					'open_data': _obj,
				}
				let res = await EloginApi.openBox(data)
				if(res){
					if(res.meta.code == 200){
						// uni.showToast({title:"已为您打开箱门", icon:"none"});
						vm.$router.push({
							path:'/CEsite40s/EOutDoor'
						})
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//获取code码
			getCode(val) {
				this.Outform.LastFour = val
			},
			getCode2(val) {
				this.Outform.PickPassword = val
			},
			//开门
			ToOutDoor(){
				vm.$router.push({
					path:'/CEsite40s/EOutDoor'
				})
			},
			//重置时间
			reTime(){
				vm.$store.state.overTime = 80
			},
			//返回上一页
			backUp(){
				vm.$router.push({
					path:'/CEsite40s'
				})
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/CEsite40s'
				})
			},
			//超时
			CountDown(wait){
				var that = vm;
				if(wait == 40) {
					clearTimeout(that.CountTimeStatus)
					that.isCount = false
					vm.cancelScanCode();//取消扫码
				} else {
					vm.CountTime = wait
					wait --;
					that.CountTimeStatus = setTimeout(function() {
						that.CountDown(wait);
					},1000);
				}
			},
		},
		watch:{
			"$store.state.wsMsg":function(newVal){
				conLog('msg2',newVal)
				vm.getSkMsg(newVal)
			}
		},
		destroyed(){
			clearTimeout(vm.CountTimeStatus)
		},
		
	}
</script>

<style lang="less">
.EOutStock{
	height: 100vh;
	background: #fff;
	text-align: center;
	.w280{
		width: 2.8rem;
	}
	.w420{
		width: 4.2rem;
	}
	.tit{
		color: #31a3dc;
		padding-top: 1.2rem;
		font-size: 0.45rem;
		margin-bottom: 0.3rem;
	}
	.outCont{
		font-size: 0.38rem;
		color: #31a3dc;
		text-align: left;
		margin: 0.6rem auto 0;
		width: 55%;
		&.isEnglish{
			width: 90%;
		}
		.item{
			margin-bottom: 0.7rem;
		}
	}
	.Outform{
		width: 45%;
		margin: 0.1rem auto 0.3rem;
		position: relative;
		.confirmBtn{
			background:url(../../../../static/CESite40s/images/btn_red_circle_normal.png) no-repeat;
			background-size: cover;
			width: 2rem;
			height: 2rem;
			color: #31a3dc;
			font-size: 0.3rem;
			position: absolute;
			left: 100%;
			top: -0.25rem;
			line-height: 2rem;
			border-radius: 50%;
			z-index: 10;
			&:active{
				background:url(../../../../static/CESite40s/images/btn_red_circle_focus.png) no-repeat;
				background-size: cover;
			}
			.time{
				position: absolute;
				width: 100%;
				bottom: 0.4rem;
				left: 0;
				line-height: 1;
			}
		}
		.item{
			display: flex;
			align-items: center;
			height: 0.7rem;
			line-height: 0.7rem;
			margin-bottom: 0.2rem;
			.itCont{
				position: relative;
				overflow: hidden;
				width: 100%;
				.itInput{
					position: absolute;
					height: 0.7rem;
					min-height: 0.7rem;
					line-height: 0.7rem;
					width: 130%;
					letter-spacing: 0.55rem;
					text-indent: 0.3rem;
					left: 0;
					top: 0;
					color: #333;
					font-size: 0.3rem;
					font-weight: bold;
					text-align: left;
					resize: none;
					outline: none;
					caret-color: rgba(0, 0, 0, 0);
				}
				.inputSpan{
					display: flex;
					border: 0.02rem solid #31a3dc;
					.itSpan{
						height: 0.7rem;
						line-height: 0.7rem;
						width: 0.7rem;
						flex-shrink: 0;
						border-right: 0.01rem solid #ddd;
						&:last-child{
							border-right: none;
						}
					}
				}
			}
			.label{
				background: #31a3dc;
				border-radius: 0.1rem;
				font-size: 0.36rem;
				width: 3rem;
				height: 0.7rem;
				line-height: 0.7rem;
				flex-shrink: 0;
				margin-right: 0.2rem;
			}
		}
	}
	
	.overTime{
		color: #666;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/OutStock/OutStock.vue